var _classCallCheck = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

/**
 * None
 */
var None = /*#__PURE__*/function () {
  "use strict";

  function None() {
    _classCallCheck(this, None);
  }

  _createClass(None, [{
    key: "sign",

    /**
     * sign
     */
    value: function sign() {
      return Promise.resolve('');
    }
    /**
     * verify
     */

  }, {
    key: "verify",
    value: function verify() {// this will never get called. but you looked.
    }
  }]);

  return None;
}();
/**
 * Export
 */


module.exports = None;